import { isNumber, parseNumber } from 'intl-utils';
import { onPageLoad } from 'runtime';
import { fetch } from 'utils';

onPageLoad(import.meta, () => {
    const cart = document.getElementById('cart');
    let timer, quantity = 0;

    cart.addEventListener('incrementQuantity', e => {
        // Make sure it is not updating.
        if (e.detail.item.updating === true)
            return;

        // Increment the displayed quantity.
        e.detail.item.quantity += e.detail.quantity;

        // Increment the quantity to update (this is the quantity changed since it was last pushed).
        quantity += e.detail.quantity;

        // Update the quantity on the server.
        updateQuantity(e.detail.item);
    });

    cart.addEventListener('updateQuantity', e => {
        const originalQuantity = e.detail.item.quantity;

        if (!isNumber(e.target.value)) {
            if (timer)
                clearTimeout(timer);

            return;
        }

        // Update the displayed quantity.
        e.detail.item.quantity = parseNumber(e.target.value);

        // Increment the quantity to update (this is the quantity changed since it was last pushed).
        quantity += e.detail.item.quantity - originalQuantity;

        // Update the quantity on the server.
        updateQuantity(e.detail.item);
    });

    function updateQuantity(item) {
        // Set the increment quantity. This allows you to decrement it from the item quantity (which is updated) to get the quantity before it is updated.
        item.incrementQuantity = quantity;

        // Make sure the user has stopped clicking the increment button before pushing the changes.
        if (timer)
            clearTimeout(timer);

        timer = setTimeout(async () => {
            // Set that it is updating. This is not contained in the response data and is therefore set to undefined once updated.
            item.updating = true;

            // Update the quantity.
            await handleResponse(await fetch(`/api/cart/${item.id}?quantity=${quantity}`, {
                method: 'PUT'
            }));

            // Reset the quantity.
            quantity = 0;
        }, 500);
    }

    cart.addEventListener('removeItem', async e => {
        await handleResponse(await fetch(`/api/cart/${e.detail.id}`, {
            method: 'DELETE'
        }));
    });

    async function handleResponse(response) {
        if (!response.ok)
            return;

        const data = await response.json();
        cart.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
    }
});